import React from 'react';
import {
  Button,
  PopoverBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  UncontrolledPopover,
} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FMessage } from '../../../hoc/IntlComponents';
import SubIdsModal from '../../../modals/SubIdsModal/SubIdsModal';

const View = ({
  open,
  data,
  label,
  id,
  placement,
  placeholder,
  disabled,
  slavesList,
  toggle,
  handleSubIdChange,
  handleSubIdApply,
  handleSubIdClear,
}) => {
  return (
    <span id="subIds-filter">
      <Button
        size="sm"
        color="light"
        id={id}
        active={open}
        onClick={toggle}
        outline
        disabled={disabled}
        className="btn-toggler"
      >
        {label}
        <i className="dropdown-toggle" />
        <span className="arrow" />
      </Button>

      {open && (
        <SubIdsModal
          isOpen={open}
          data={data}
          handleSubIdChange={handleSubIdChange}
          handleSubIdApply={handleSubIdApply}
          handleSubIdClear={handleSubIdClear}
          handleClose={toggle}
          placeholder={placeholder}
          slavesList={slavesList}
        />
      )}

      {disabled && (
        <UncontrolledPopover
          target="subIds-filter"
          className="tooltip-subId"
          trigger="hover"
          placement={placement}
        >
          <PopoverBody>
            <FMessage id="statistics.filters.subids.disabled.max90" />
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </span>
  );
};

export default View;
